export enum CreateObjectStepId {
  ObjectType = 'object-type',
  Photos = 'photos',
  Address = 'address',
  AddressMap = 'address-map',
  Amenities = 'amenities',
  AdditionalAmenities = 'additional-amenities',
  Description = 'description',
  Price = 'price',
  Conditions = 'conditions',
  Confirmation = 'confirmation',
}

export interface CreateObjectDictionaryItem {
  id: string
  titleKey: string
  descriptionKey?: string
}

export interface CreateObjectDraft {
  objectTypeId?: string
  photoIds?: string[]
  address?: {
    city?: string
    street?: string
    house?: string
    latitude?: number
    longitude?: number
  }
  amenityIds?: string[]
  title?: string
  description?: string
  roomsCount?: number
  guestsCount?: number
  pricePerNight?: number
  cancellationPolicyId?: string
  requiresBookingConfirmation?: boolean
}
